// LogTab.jsx — Nastavenia → LOG zmien (audit_log prehliadač). Mirko 2026-06-04.
// Fáza 1: čítanie. Trojitá ochrana dát (③). Backend: GET /api/audit-log (+stats).
import React, { useState, useEffect } from 'react'
import { fetchAuth } from '../auth/fetchAuth.js'
import { useToast } from '../components/Toast.jsx'
import { usePinGate } from '../hooks/usePinGate.jsx'

const REVERTABLE = ['work-schedule', 'vymery', 'customers', 'expenses', 'income', 'projects', 'zamestnanci']

const ACT_LABEL = { create: 'Pridané', edit: '✎ Upravené', update: '✎ Upravené', delete: 'Zmazané', archive: 'Archivované', restore: '↩ Obnovené', complete: 'Uzamknuté', login: 'Prihlásenie', merge_hard_delete: 'Zlúčené' }
const actLabel = a => ACT_LABEL[a] || a
const fmtDate = s => (s || '').replace('T', ' ').slice(0, 16)
const short = (o) => { if (o == null || o === '') return ''; try { const j = typeof o === 'string' ? JSON.parse(o) : o; return Object.entries(j).filter(([k, v]) => v != null && v !== '' && !['id', 'created_at', 'updated_at'].includes(k)).map(([k, v]) => k + ': ' + String(v).slice(0, 30)).join(' · ') } catch (_) { return String(o).slice(0, 120) } }

export default function LogTab() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [modules, setModules] = useState([])
  const [users, setUsers] = useState([])
  const [fMod, setFMod] = useState('')
  const [fUser, setFUser] = useState('')
  const [search, setSearch] = useState('')
  const [showNoise, setShowNoise] = useState(false)
  const [openId, setOpenId] = useState(null)
  const toast = useToast()
  const pinGate = usePinGate()

  const doRevert = async (r) => {
    if (!window.confirm('Vrátiť tento záznam do predošlého stavu?\n\n' + r.module + ' · ' + (r.entity_id || '') + '\n' + (r.detail || ''))) return
    const gate = await pinGate('audit_revert', { modul: r.module, id: r.entity_id })
    if (!gate || !gate.ok) { toast.error('Vrátenie zrušené — bez Admin PINu sa nič nemení.'); return }
    let qs = ''
    for (let attempt = 0; attempt < 2; attempt++) {
      const rr = await fetchAuth('/api/audit-log/' + r.id + '/revert' + qs, { method: 'POST', headers: { 'X-Pin-Audit-Id': String(gate.audit_id || '') } })
      if (rr.ok) { toast.success('↩ Vrátené: ' + r.module + ' · ' + (r.entity_id || '')); load(); return }
      const err = await rr.json().catch(() => ({}))
      if ((err.error === 'NEWER_CHANGE' || err.error === 'TOO_OLD') && attempt === 0) {
        if (!window.confirm((err.message || 'Blokované bezpečnosťou') + '\n\nNapriek tomu prepísať (force)?')) return
        qs = '?force=1'; continue
      }
      toast.error('Vrátenie zlyhalo: ' + (err.message || err.error || rr.status)); return
    }
  }

  const load = async () => {
    setLoading(true)
    try {
      const qs = new URLSearchParams()
      qs.set('limit', '300')
      if (!showNoise) qs.set('exclude_noise', '1')
      if (fMod) qs.set('module', fMod)
      if (fUser) qs.set('user', fUser)
      if (search.trim()) qs.set('search', search.trim())
      const r = await fetchAuth('/api/audit-log?' + qs.toString())
      const data = await r.json()
      setRows(Array.isArray(data) ? data : [])
    } catch (e) { setRows([]) }
    setLoading(false)
  }
  useEffect(() => { fetchAuth('/api/audit-log/stats').then(r => r.json()).then(d => { setUsers(d.users || []); setModules((d.byModule || []).map(m => m.module).filter(m => !['user-activity', 'locks', 'activity-log'].includes(m))) }).catch(() => {}) }, [])
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t) }, [fMod, fUser, search, showNoise])

  const C = { border: '1px solid #d6dde6', borderRadius: 8, padding: '6px 9px', fontSize: 13, fontFamily: 'inherit', background: '#fff' }
  const TH = { padding: '7px 9px', background: '#dde9f3', border: '1px solid #dbe6ef', fontSize: 10, fontWeight: 800, textTransform: 'uppercase', color: '#6b7480', textAlign: 'left', whiteSpace: 'nowrap', position: 'sticky', top: 0 }
  const TD = { padding: '6px 9px', border: '1px solid #eef2f7', fontSize: 13, color: '#1c2330', verticalAlign: 'top' }

  return (
    <div>
      <div style={{ fontSize: 12, color: '#5b6573', background: 'rgba(2,132,199,.06)', border: '1px solid rgba(2,132,199,.25)', borderRadius: 8, padding: '9px 12px', marginBottom: 12 }}>
        <b>LOG zmien — tretia vrstva ochrany dát</b> (zálohy · soft-delete · LOG). Kto · čo · kedy. Systémové pingy (prihlásenia/zámky) sú skryté — zapni „aj systémové" ak ich chceš. <i>Vrátenie (revert) = ďalšia fáza.</i>
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginBottom: 12 }}>
        <select value={fMod} onChange={e => setFMod(e.target.value)} style={C}><option value="">Všetky moduly</option>{modules.map(m => <option key={m} value={m}>{m}</option>)}</select>
        <select value={fUser} onChange={e => setFUser(e.target.value)} style={C}><option value="">Všetci používatelia</option>{users.map(u => <option key={u} value={u}>{u}</option>)}</select>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="hľadať (popis / id / meno)…" style={{ ...C, minWidth: 220 }} />
        <label style={{ fontSize: 12, color: '#5b6573', display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer' }}><input type="checkbox" checked={showNoise} onChange={e => setShowNoise(e.target.checked)} /> aj systémové</label>
        <button onClick={load} style={{ ...C, cursor: 'pointer', fontWeight: 700, color: '#0369a1' }}>↻ Obnoviť</button>
        <span style={{ marginLeft: 'auto', fontSize: 12, color: '#5b6573' }}>{loading ? 'Načítavam…' : rows.length + ' záznamov'}</span>
      </div>
      <div style={{ overflow: 'auto', maxHeight: '62vh', border: '1px solid #d6dde6', borderRadius: 10 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr><th style={TH}>Kedy</th><th style={TH}>Kto</th><th style={TH}>Modul</th><th style={TH}>Akcia</th><th style={TH}>Popis</th><th style={TH}>Zmena</th></tr></thead>
          <tbody>
            {rows.map(r => {
              const hasData = (r.old_data && r.old_data !== '') || (r.new_data && r.new_data !== '')
              const isOpen = openId === r.id
              return <React.Fragment key={r.id}>
                <tr style={{ background: r.action === 'archive' || r.action === 'delete' ? '#fff7f7' : r.action === 'restore' ? '#f3fbf5' : '#fff' }}>
                  <td style={{ ...TD, whiteSpace: 'nowrap', color: '#5b6573', fontVariantNumeric: 'tabular-nums' }}>{fmtDate(r.created_at)}</td>
                  <td style={{ ...TD, fontWeight: 700 }}>{r.username || '—'}</td>
                  <td style={{ ...TD, color: '#0369a1' }}>{r.module}</td>
                  <td style={{ ...TD, whiteSpace: 'nowrap', fontWeight: 700 }}>{actLabel(r.action)}</td>
                  <td style={TD}>{r.entity_name ? <b>{r.entity_name}</b> : null} {r.detail || ''} {r.entity_id ? <span style={{ color: '#94a3b8', fontSize: 11 }}>({r.entity_id})</span> : null}</td>
                  <td style={TD}><div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>{hasData ? <button onClick={() => setOpenId(isOpen ? null : r.id)} style={{ border: '1px solid #d6dde6', background: '#fff', borderRadius: 6, padding: '2px 8px', cursor: 'pointer', fontSize: 11, fontWeight: 700, color: '#b45309' }}>{isOpen ? '▾ skryť' : '▸ old→new'}</button> : <span style={{ color: '#cbd5e1' }}>—</span>}{hasData && REVERTABLE.includes(r.module) && <button onClick={() => doRevert(r)} title="Vrátiť do predošlého stavu (Admin PIN)" style={{ border: '1px solid #15171A', background: '#FBFAF7', borderRadius: 6, padding: '2px 8px', cursor: 'pointer', fontSize: 11, fontWeight: 800, color: '#b45309' }}>↩ Vrátiť</button>}</div></td>
                </tr>
                {isOpen && hasData && <tr><td colSpan={6} style={{ ...TD, background: '#fafbfd' }}>
                  <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', fontSize: 12 }}>
                    <div style={{ flex: '1 1 280px' }}><div style={{ fontWeight: 800, color: '#dc2626', marginBottom: 3 }}>Pred (old)</div><div style={{ color: '#5b6573' }}>{short(r.old_data) || '—'}</div></div>
                    <div style={{ flex: '1 1 280px' }}><div style={{ fontWeight: 800, color: '#41694C', marginBottom: 3 }}>Po (new)</div><div style={{ color: '#5b6573' }}>{short(r.new_data) || '—'}</div></div>
                  </div>
                </td></tr>}
              </React.Fragment>
            })}
            {!loading && rows.length === 0 && <tr><td colSpan={6} style={{ ...TD, textAlign: 'center', color: '#94a3b8', padding: 24 }}>Žiadne záznamy pre tento filter.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  )
}
